import { Button } from "../button";
import { Icon } from "../icons";
import { MapMenu } from "./map-menu";

export type View = "default" | "maximized";

/** Props Interface */
interface MapControlsProps {
	view: View;
	setView: (view: View) => void;
}

export function MapControls({ view, setView }: MapControlsProps) {
	function handleOnToggleView() {
		return setView(view === "default" ? "maximized" : "default");
	}

	/** Render */
	return (
		<div className="top-2 right-2 left-2 z-10 absolute h-stack">
			<Button
				icon={<Icon name="Maximize" />}
				onClick={handleOnToggleView}
			/>
			<div className="flex-1" />
			<MapMenu />
		</div>
	);
}
